import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-material-issue-requests',
  templateUrl: './material-issue-requests.component.html',
  styleUrls: ['./material-issue-requests.component.css']
})
export class MaterialIssueRequestsComponent implements OnInit {

  data: any;
  cid:any
  quantityArr:any = []
  issueQuantity = ""
  form: any | FormGroup
  modelSubtitle = false
  id = ''
  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  products: any = [];
  vendor: any = [];
  branch: any = [];
  materials: any = [];
  InfoObj:any = []
  make:any = ''
  modal:any = ''
  slNo:any = ''
  expiryDate:any = ''
  userid:any =''
  materialdata: any = [];
  materialstatus: any = [];
  editform: any | FormGroup;
  viewProd:any = []
  viewData:any = []
  statusdata: any = [];
  productSerialNoList:any = []
  singleissue: any = [];
  
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

 constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action

  this.cid = sessionStorage.getItem('cid')
    this.getAllMaterilaIssueByStatus(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      branchId :[''],
      branchName:[''],
      vendorName:[''],
      productName:[''],
      quantity:[''],
      createdByUserName:[''],
      createdDate:[''],
      issueNo:[''],
      issueDate:[''],
      infoObj:this.fb.array([]),
    })  

    this.editform = this.fb.group({
      branchId :[''],
      branchName:[''],
      vendorName:[''],
      productName:[''],
      quantity:[''],
      issueNo:[''],
      issueDate:[''],
      infoObj:this.fb.array([]),
    })  

    // this.generic_service.getProduct().subscribe(
    //   (res:any)=>{
    //     this.products = res.response
    //   }
    // )

    // this.generic_service.getVendor().subscribe(
    //   (res:any)=>{
    //     this.vendor = res.response
    //   }
    // )

    this.generic_service.getBranch().subscribe(
      (res:any)=>{
        this.branch = res.response
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllMaterilaIssueByStatus(this.pageNumber,this.recordsPerPage)
  }

  get infoArr(){
    return this.form.get('infoObj') as FormArray;
  }

  InfoObject(){
    return this.fb.group({
      "make": [''],
      "modal": [''],
      "slNo": [''],
      "expiryDate": [''],
    })
   }

   addInfoObject(qty:any){
    this.infoArr.clear()
    let q = Number(qty)
    console.log(q)
    for(let i=0;q>i;i++){
      this.infoArr.push(this.InfoObject())
    }
   }

 removeInfoObject(index: number){
  this.infoArr.removeAt(index)
 }

klp(){
  console.log(this.form.value)
}

 resetInfoObject(){
  this.make = ''
  this.modal = ''
  this.slNo = ''
  this.expiryDate = ''
 }





approveIssue(){
  // for(let i=0;i<this.productSerialNoList.length;i++){
  //   delete this.productSerialNoList[i].requestQty
  // }

  let productSerialNoList: any = []

  for(let i=0;i<this.productSerialNoList.length;i++){
    let obj = {
      approveQty : this.productSerialNoList[i].approveQty,
      infoObj : this.productSerialNoList[i].infoObj,
      productName : this.productSerialNoList[i].productName,
      uomName : this.productSerialNoList[i].uomName,
    }

    let infoObj = {
      "make": "",
      "modal": "",
      "slNo": 0,
      "expiryDate": 0,
      "url": "",
      "lat": "",
      "lon": "",
    }
    for(let i=0;obj.approveQty>i;i++){
      obj.infoObj.push(infoObj)
    }

     productSerialNoList.push(obj)
  }

  let body = {
    "id": Number(this.id),
    "issueStatusDTO": {
      "userId": Number(sessionStorage.getItem("userId")),
      "issueStatus": "APPROVED",
      "updatedDate": new Date().getTime()
    },
    "productSerialNoList": productSerialNoList
  }
  console.log(body)

  // let body = {
  //   "version": 0,
  //   "isActive": true,
  //   "description": "string",
  //   "id": String(this.id),
  //   "branchId": Number(this.form.get('branchId').value),
  //   "branchName":  String(this.form.get('branchName').value),
  //   "vendorName":  String(this.form.get('vendorName').value),
  //   "productName":  String(this.form.get('productName').value),
  //   "issueNo": Number(this.form.get('issueNo').value),
  //   "issueDate": new Date(this.form.get('issueDate').value).getTime(),
  //   "status": [
  //     {
  //       "userId": String(sessionStorage.getItem("userId")),
  //       "issueStatus": "Approved",
  //     }
  //   ],
  //   "tranType": "ISSUE",
  //   "infoObj": this.form.get('infoObj').value,
  //   "quantity":  this.InfoObj.length,
    
  // }

  // console.log(body)
  this.generic_service.approveIssue(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllMaterilaIssueByStatus(0,this.recordsPerPage)
      this.toastr.success(response.message);
      this.cancelModel()
      // this.InfoObj = []

    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);

    },
  )
}

rejectIssue(){
  for(let i=0;i<this.productSerialNoList.length;i++){
    delete this.productSerialNoList[i].requestQty
  }
  let body = {
    "id": Number(this.id),
    "issueStatusDTO": {
      "userId": String(sessionStorage.getItem("userId")),
      "issueStatus": "REJECTED",
      "updatedDate": new Date().getTime()
    },
    "productSerialNoList": this.productSerialNoList
  }
  console.log(body)

  this.generic_service.approveIssue(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllMaterilaIssueByStatus(0,this.recordsPerPage)
      this.toastr.success(response.message);
      this.cancelModel()
      this.InfoObj = []

    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);

    },
  )
}

cancelModel(){
  document.getElementById("closeModalButton")?.click()
  document.getElementById("closeModalButton1")?.click()
}

getAllMaterilaIssueByStatus(pageNumber:any,recordsPerPage:any){
  this.isLoading = true

  this.generic_service.getAllMaterilaIssueByStatus(pageNumber,recordsPerPage,'REQUESTED').subscribe(
    (response:any)=>{
      this.materials = response.response.materialIssueList;
      this.totalRecords = response.response.totalRecords
      this.materialstatus = response.response.status;
      console.log(response)
      this.isLoading = false

    }
  )
}
// getMaterialByID(id:any){
//   this.generic_service.getMaterialByID(id).subscribe(
//     (res:any)=>{
//       this.materialdata = [];
//       this.materialdata.push(res.response);
//     }
//   )
// }

getViewById(id:any){
  this.id = id
  this.generic_service.getMaterialIssueById(id).subscribe(
    (response:any)=>{
      console.log(response)
      this.productSerialNoList = []
      this.singleissue = []
      this.singleissue.push(response.response)
      let iDate = "--"
      if(response.response.issueDate != 0 && response.response.issueDate != null){
        iDate = formatDate(response.response.issueDate, 'yyyy-MM-dd', 'en-US')
      }

      let createdDate = "--"
      if(response.response.createdDate != 0 && response.response.createdDate != null){
        createdDate = formatDate(response.response.createdDate, 'yyyy-MM-dd', 'en-US')
      }
      this.form.patchValue({
      branchId :response.response.branchId,
      branchName:response.response.branchName,
      vendorName:response.response.vendorName,
      productName:response.response.productList[0].productName,
      quantity:response.response.productList[0].quantity,
      issueNo:String(response.response.issueNo),
      createdByUserName:response.response.productList[0].createdByUserName,
      createdDate:createdDate,
      issueDate: iDate

      })
      for(var i=0; i<response.response.productList.length; i++){
        let body = {
          "productName": response.response.productList[i].productName,
          "requestQty": response.response.productList[i].quantity,
          "approveQty": response.response.productList[i].quantity,
          "uomName": response.response.productList[i].uomName,
          "infoObj": []
        }

        let body1 = {
          "productName": response.response.productList[i].productName,
          "requestQty": response.response.productList[i].quantity,
          "approveQty": response.response.productList[i].quantity,
          "uomName": response.response.productList[i].uomName,
          "infoObj": []
        }

        if(response.response.latestStatus == "REQUESTED"){
          this.productSerialNoList.push(body)
        }else{
          this.productSerialNoList.push(body1)
        }
      }
      console.log(this.form.value)
    },
    (error)=>{
      console.log(error)
    }
  )
}

// addInfoObj(index:any,Qty:any) {
//   console.log(Qty)
//   let obj = {
//     "make": "",
//     "modal": "",
//     "slNo": 0,
//     "expiryDate": 0,
//     "url": "",
//     "lat": "",
//     "lon": "",
//   }
//   if(this.productSerialNoList[index].requestQty >= this.productSerialNoList[index].approveQty){
//     for(let i=0;this.productSerialNoList[index].approveQty>i;i++){
//       this.productSerialNoList[index].infoObj.push(obj)
//     }
//   }else{
//     this.productSerialNoList[index].infoObj = []
//   }
//   console.log(this.productSerialNoList)
// }

getAllProduct(){
  // this.generic_service.getProduct().subscribe(
  //   (res:any)=>{
  //     this.products = res.response
  //   }
  // )
}

getAllVendor(){
  // this.generic_service.getVendor().subscribe(
  //   (res:any)=>{
  //     this.vendor = res.response
  //   }
  // )
}

getAllBranch(){
  this.generic_service.getBranch().subscribe(
    (res:any)=>{
      this.branch = res.response
    }
  )
}


open() {
  this.modelSubtitle = true;
}
close() {
  this.modelSubtitle = false;
  this.name = ""
  this.version = ""
  this.isActive = false
  
}

quantity(){
  let body = {
    "make": "",
    "modal": "",
    "slNo": "",
    "expiryDate": ""
  }

  let quantity = Number(this.form.get('quantity').value)
  let arr = []
  if(quantity != 0 || quantity != null){
    for(let i=0;quantity > i;i++){
      arr.push(body)
    }
    this.quantityArr = arr
  }
}

qty(value: any){
  let quantity = Number(this.form.get('quantity').value)
  console.log(quantity)
  if(quantity >= value){
    this.addInfoObject(value)
  }else{
    console.log(value)
    console.log("entered quantity is greater than requested quantity")
    this.toastr.error("entered quantity is greater than requested quantity")
    this.infoArr.clear()

  }
}


searchKey: any = ""

getAllMaterialIssueByWildSearchWithIssueStatus(pageNumber: any,recordsPerPage: any){
  console.log(this.searchKey)
  if(this.searchKey != ""){
    this.isLoading = true

    this.generic_service.getAllMaterialIssueByWildSearchWithIssueStatus(this.searchKey,'APPROVED',pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response);
        this.materials = response.response.materialIssueList;
        this.totalRecords = response.response.totalRecords
        this.materialstatus = response.response.status;
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }else{
    this.getAllMaterilaIssueByStatus(this.pageNumber,this.recordsPerPage)
  }
}

refreshSearch(){
  this.searchKey = ""
  this.getAllMaterilaIssueByStatus(this.pageNumber,this.recordsPerPage)
}


  refreshAll(){
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllMaterilaIssueByStatus(this.pageNumber,this.recordsPerPage)
  }

}